export default "__VITE_ASSET__2_kUh4dF__";